import { setAccessToken, getAccessToken } from 'services/localStorage';
import { auth } from 'utils/firebase';

const renewToken = async () => {
  const accessToken = await auth.currentUser?.getIdToken(true);
  setAccessToken(accessToken || getAccessToken());
};

export const startAuthMonitoring = (): NodeJS.Timeout => {
  const fiftyMinutes = 50 * 60 * 1000;
  return setInterval(renewToken, fiftyMinutes);
};
